// @flow
import { combineReducers } from 'redux';

import Auth from './auth/reducers';
import Layout from './layout/reducers';
import Orders from './orders/reducers';
import Shipments from './shipments/reducers';
import ActivityLog from './activity-log/reducers';
import Adjustments from './adjustments/reducers';
import Manifests from './manifests/reducers';
import Integrations from './integrations/reducers';
import EditOrder from './edit-order/reducers';
import ViewOrder from './view-order/reducers';
import NewOrder from './new-order/reducers';
import AddressBook from './addressbook/reducers';
import Manifest from './manifest/reducers';
import Profile from './profile2/reducers';
import LocalStorage from './local-storage/reducers';
import PackageItems from './package-items/reducers';
import Toast from './toast/reducers';
import LabelAndDocsSettings from './labels-docs-settings/reducers';
import Package from './package/reducers';
import PackageSettings from './package-settings/reducers';
import BillingModal from './billing-modal/reducers';
import Billing from './billing/reducers';
import IntegrationErrors from './integration-errors/reducers';
import Agents from './agents/reducers';
import Carrier from './carrier/reducers';
import Automation from './automation/reducers';
import Invitation from './invitation/reducers';
import Batches from './batches/reducers';
import OrderBatchErrors from './order-batch-errors/reducers';
import Products from './products/reducers';
import CommerceShipConnectors from './commerceship-connectors/reducers';
import SquareConnectors from './square-connectors/reducers';
import OrderAnalytics from './order-analytics/reducers';
import WeatherImpact from './weather-impact/reducers';
import ShipmentsKpis from './shipments-kpis/reducers';
import SavingsKpis from './savings-kpis/reducers';
import ZonesKpis from './zones-kpis/reducers';
import RateSets from './rate-sets/reducers';
import ScenarioOptimizations from './scenario-optimizations/reducers';
import ServiceLevelsKpis from './service-levels-kpis/reducers';
import SurchargesKpis from './surcharges-kpis/reducers';
import SurchargesOptimizations from './surcharges-optimizations/reducers';
import TotalCostOptimizations from './total-cost-optimizations/reducers';
import Warehouses from './warehouses/reducers';
import Locations from './locations/reducers';
import Inventory from './inventory/reducers';
import RatingJobs from './rating-jobs/reducers';
import IntegrationTypes from './integration-types/reducers';
import TrackingStatusAnalytics from './tracking-status-analytics/reducers';
import TransitTimesAnalytics from './transit-times-analytics/reducers';
import DeliveryPerformanceAnalytics from './delivery-performance-analytics/reducers';
import TrackingReports from './tracking-reports/reducers';
import TrackingEvents from './tracking-events/reducers';
import ShipmentTrackingRecords from './shipment-tracking-records/reducers';
import IntegrationSummaryAnalytics from './integration-summary-analytics/reducers';
import CarrierOptimizations from './carrier-optimizations/reducers';
import OperationalOptimizations from './operational-optimizations/reducers';
import Users from './users/reducers';
import FinancialsKpis from './financials-kpis/reducers';
import AdjustmentJobs from './adjustment-jobs/reducers';
import SyncJobs from './sync-jobs/reducers';
import ApiKeys from './api-keys/reducers';
import Jobs from './jobs/reducers';

export default (combineReducers({
    Auth,
    Layout,
    Orders,
    Shipments,
    ActivityLog,
    Adjustments,
    Manifests,
    Integrations,
    EditOrder,
    ViewOrder,
    NewOrder,
    AddressBook,
    Manifest,
    Profile,
    LocalStorage,
    PackageItems,
    Toast,
    LabelAndDocsSettings,
    Package,
    PackageSettings,
    BillingModal,
    Billing,
    IntegrationErrors,
    Agents,
    Carrier,
    Automation,
    Invitation,
    Batches,
    OrderBatchErrors,
    Products,
    CommerceShipConnectors,
    SquareConnectors,
    OrderAnalytics,
    WeatherImpact,
    ShipmentsKpis,
    SavingsKpis,
    ZonesKpis,
    RateSets,
    ScenarioOptimizations,
    ServiceLevelsKpis,
    SurchargesKpis,
    SurchargesOptimizations,
    TotalCostOptimizations,
    Warehouses,
    Locations,
    Inventory,
    RatingJobs,
    IntegrationTypes,
    TrackingStatusAnalytics,
    TransitTimesAnalytics,
    DeliveryPerformanceAnalytics,
    TrackingReports,
    TrackingEvents,
    ShipmentTrackingRecords,
    IntegrationSummaryAnalytics,
    CarrierOptimizations,
    OperationalOptimizations,
    Users,
    FinancialsKpis,
    AdjustmentJobs,
    SyncJobs,
    ApiKeys,
    Jobs,
}));
